import {useQuery} from "react-query";
import {http} from "../../../services/api/restApiClient";
import {buildResponseErrorMessage} from "../../../services/api/errorHelpers";
import {PccFacilityMappingModel} from "../../../utils/types/facility";

type Params = {
  facilityId: string;
  enabled?: boolean;
};

export const usePccFacilityMappingQuery = ({facilityId, enabled}: Params) =>
  useQuery(
    ["getPccFacilityMapping", facilityId],
    async ({queryKey: [_, facilityId]}) => {
      const {data} = await http.get<PccFacilityMappingModel>(`/facilities/${facilityId}/pcc-mapping`);
      return data;
    },
    {
      cacheTime: 0,
      // Only fetch the mapping when PCC is enabled for the facility; skips the
      // call (and its error) when PCC is turned off, e.g. locally with no mock.
      enabled: Boolean(enabled),
      onError: async resp => {
        await buildResponseErrorMessage(
          resp,
          "Failed to fetch PointClickCare facility mapping. Please, try again later.",
        );
      },
    },
  );
